// Full-document render of the stearns OfferDetailPage: PageSkeleton (the React
// document shell) wrapping the {% block layout %} DOM the legacy template built
// around the OfferDetailContent body island -- the offer_type-modified
// .offer-details-page wrapper, the breadcrumbs, the header, and the history-back
// link. The former inline `onclick="window.history.back();return false;"` is a
// React onClick handler on the same (now React-owned) div; the markup is
// otherwise byte-faithful. The |safe copy fields (header_text) and the
// |richtext-expanded pre_header_text are trusted CMS HTML injected raw so
// entities pass through unescaped, matching the legacy output.
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { OfferDetailPageBody } from "../components/OfferDetailPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props. The body template accepts Immutable props, to which
// these are assignable.
export const Template = (
    props: templates.OfferDetailPageTemplate,
): React.JSX.Element => {
    const { page } = props;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div
                className={`offer-details-page offer-details-page--${page.offer_type} u-full-width-title l-capped-width`}
            >
                <div className="offer-details-page__breadcrumbs">
                    <a href={props.offers_url}>{t`Offers`}</a>
                    {page.header_text ? (
                        <>
                            {" > "}
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: page.header_text,
                                }}
                            />
                        </>
                    ) : null}
                </div>
                <header className="offer-details-page__header">
                    {props.pre_header_html ? (
                        <div>
                            <h6
                                dangerouslySetInnerHTML={{
                                    __html: props.pre_header_html,
                                }}
                            />
                        </div>
                    ) : null}
                    {page.header_text ? (
                        <h1
                            dangerouslySetInnerHTML={{
                                __html: page.header_text,
                            }}
                        />
                    ) : null}
                    <div className="offer-details-page__bar"></div>
                </header>

                <section className="offer-details-page__content">
                    <OfferDetailPageBody page={page} />
                </section>
                <div
                    className="offer-details-page__back-link"
                    onClick={() => {
                        getWindow()?.history.back();
                    }}
                >
                    {"< "}
                    {t`Back`}
                </div>
            </div>
        </PageSkeleton>
    );
};
